import React, { memo } from "react"
import PropTypes from "prop-types"
import { TabPane } from "reactstrap"
import DateTabs from "components/weather/DateTabs"
import Chart from "components/weather/Chart"

import moment from "moment"
import { numberFormat } from "helpers/string"

import { useSelector } from "react-redux"
import { dateHourlyForecastSelector, forecastDateSelector } from "store/weather"

Humidity.propTypes = {
  className: PropTypes.string,
  params: PropTypes.object.isRequired,
  onChangeFilters: PropTypes.func.isRequired
}
function Humidity({ className, params, onChangeFilters }) {
  const hourlyForecast = useSelector(dateHourlyForecastSelector())
  const forecastDate = useSelector(forecastDateSelector)

  if (!hourlyForecast) return null

  const currentTime = moment().format("HH:[00]")
  const currentTimePlusOne = moment().add(1, "hours").format("HH:[00]")
  const currentTimeData = hourlyForecast[currentTime] || hourlyForecast[currentTimePlusOne]

  const today = moment()
  const dateMoment = moment(forecastDate || today)
  const isToday = today.isSame(dateMoment, "day")
  const isTomorrow = today.clone().add(1, "day").isSame(dateMoment, "day")
  const dateFormatted = dateMoment.format(`${(isToday && "[Today], ") || (isTomorrow && "[Tomorrow], ") || ""}MMM DD, YYYY`)

  const classes = ["bg-white rounded px-40 py-30 position-relative overflow-hidden"]
  if (className) classes.push(className)

  return (
    <TabPane tabId="humidity" className={classes.join(" ")}>
      <div className="vstack gap-30">
        <DateTabs params={params} onChangeFilters={onChangeFilters} />
        <div className="mt-10">
          <p className="text-dark text-opacity-50 mb-1">{dateFormatted}</p>
          <p className="fs-3 m-0">{numberFormat(currentTimeData?.relativeHumidity, { style: "unit", unit: "percent" })}</p>
        </div>
        <Chart
          hourlyData={hourlyForecast}
          color="0, 82, 180"
          fill
          yAxisKey="value.relativeHumidity"
          yFormatOptions={{ style: "unit", unit: "percent" }}
        />
      </div>
    </TabPane>
  )
}

export default memo(Humidity)
